export default [
  {
    path: '/sfda-labs',
    name: 'sfda-labs',
    component: () => import('@/views/sfda-labs/SFDALabs.vue'),
    meta: {
      title: 'SFDA Labs',
      requiresAuth: true,
      action: 'browes',
      resource: 'SFDA Labs',
      pageTitle: 'SFDA Labs',
      breadcrumb: [
        {
          text: 'SFDA Labs',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sfda-labs/add',
    name: 'add-sfda-lab',
    component: () => import('@/views/sfda-labs/control-sfda-labs/AddEditSFDALabs.vue'),
    meta: {
      title: 'Add SFDA Lab',
      requiresAuth: true,
      action: 'add',
      resource: 'SFDA Labs',
    },
  },
  {
    path: '/sfda-labs/edit/:id',
    name: 'edit-sfda-lab',
    component: () => import('@/views/sfda-labs/control-sfda-labs/AddEditSFDALabs.vue'),
    meta: {
      title: 'Edit SFDA Lab',
      requiresAuth: true,
      action: 'edit',
      resource: 'SFDA Labs',
    },
  },
]
